import copy from 'copy-to-clipboard';
import { useSnackbar } from 'notistack';
import { useCallback } from 'react';

/**
 * Trigger the share action on device that allows it, otherwise copy the URL
 */
export const useSharePage = () => {
  const { enqueueSnackbar } = useSnackbar();
  const sharePage = useCallback(() => {
    const currentUrl = window.location.href;
    const shareData = { url: currentUrl };
    if (!!navigator.canShare && navigator.canShare(shareData)) {
      navigator.share({ url: currentUrl }).catch((_error) => {
        // Nothing to do, error thrown when share dismissed without sharing
      });
    } else {
      // Copying URL to clipboard when navigator doesn't support native share
      copy(currentUrl);
      enqueueSnackbar('URL copied to clipboard', { variant: 'success' });
    }
  }, [enqueueSnackbar]);

  return { sharePage };
};
